export default "__VITE_ASSET__CtwcQWOs__"